import ProductDescription from './ProductDescription'

const BSWildRiceProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '015',
  IsBroadband: false,
  GrainLength: '',
  Size: '',
}

export default BSWildRiceProduct
